import { render, staticRenderFns } from "./CompensacaoHorasSindicato.vue?vue&type=template&id=905f9d9c&scoped=true"
import script from "./CompensacaoHorasSindicato.vue?vue&type=script&lang=js"
export * from "./CompensacaoHorasSindicato.vue?vue&type=script&lang=js"
import style0 from "./CompensacaoHorasSindicato.vue?vue&type=style&index=0&id=905f9d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905f9d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSwitch,VTextField})
